import React from "react";
import { InputRangeRow } from "./index";
// Used by Heli KV2008B and Heli KV2019B machines

export default function TensionBallsTopRow() {
   return (
      <InputRangeRow
         titleProp={"Tension Balls"}
         descriptionProp={"Top"}
         sizeProp={6}
         colSizeProp={6}
         typeProp={"text"}
         minProp={0}
         maxProp={10}
         propertyNameProp={"ballTop"}
         errorDialogueProp={"1-10 only"}
         floatProp={false}
      />
   );
}
